import { ApolloClient } from '@apollo/client'
import { TRIP_NOTE_FRAGMENT } from 'features/Trips/queries'
import { TripNoteDriverRsvpStatus, TripV2Note, TripV2NoteCategory, TripV2NoteChangeType } from 'gql/generated/graphql'

interface IUpdateManualRsvpStatusArgs {
  client: ApolloClient<TSFixMe>
  tripId: string
  driverRSVPStatus: TripNoteDriverRsvpStatus
  driver: {
    id: string
    firstName: string
    lastName: string
  }
}

export const updateManualRsvpStatus = ({
  client,
  tripId,
  driverRSVPStatus,
  driver
}: IUpdateManualRsvpStatusArgs): void => {
  const notesResponse = client.readFragment({
    id: client.cache.identify({
      __typename: 'TripV2',
      id: tripId
    }),
    fragment: TRIP_NOTE_FRAGMENT
  })

  if (!notesResponse) {
    throw new Error('Trip notes not found in cache')
  }
  client.writeFragment({
    id: client.cache.identify({
      __typename: 'TripV2',
      id: tripId
    }),
    fragment: TRIP_NOTE_FRAGMENT,
    data: {
      notes: [
        ...(notesResponse.notes as TripV2Note[]),
        {
          __typename: 'TripV2Note',
          category: TripV2NoteCategory.DriverRsvp,
          subcategory: null,
          message: '',
          changeType: TripV2NoteChangeType.AddDriverRsvpNote,
          user: {
            id: '',
            firstName: '',
            lastName: '',
            username: ''
          },
          createdAt: new Date().toISOString(),
          cashFlow: null,
          files: [],
          distance: null,
          driver: {
            id: driver?.id || '',
            firstName: driver?.firstName || '',
            lastName: driver?.lastName || '',
            rsvpStatus: driverRSVPStatus
          }
        }
      ]
    }
  })
}
